export enum AppPaths {
  Home = '/',
  Press = '/press',
  SecretRelease = '/39fj9fsnn3i7r023rhjafefe223474902',
  LatestRelease = '/latest-release',
}
